<template>
  <div class="accident-list1">
    <img src="@/assets/images/list/ang1.png" :class="ang1"/>
    <img src="@/assets/images/list/ang2.png" :class="ang2"/>
    <img src="@/assets/images/list/ang2.png" class="ang2-2"/>
    <img src="@/assets/images/list/ang3.png" class="ang3"/>
    <img src="@/assets/images/list/ang4.png" class="ang4"/>
    <div class="maincontent">
      <div class="changlistbtns">
        <div :class="commonBts1" @click="isAllList(false)">
          <span
            class="cn-title title-selected">{{
              currentRole === '保险员' || (isAdmin && loginType === '3191') ? '今日理赔' : loginType === '3187' ? '今日救援' : '今日事故'
            }}</span>
          <span
            :class="enTitle1">{{
              currentRole === '保险员' || (isAdmin && loginType === '3191') ? 'Today‘s settlement' : loginType === '3187' ? 'Today‘s rescue' : 'Today‘s accident'
            }}</span>
        </div>
        <div :class="commonBts2" @click="isAllList(true)">
          <span
            class="cn-title">{{
              currentRole === '保险员' || (isAdmin && loginType === '3191') ? '全部理赔' : loginType === '3187' ? '全部救援' : '全部事故'
            }}</span>
          <span
            :class="enTitle2">{{
              currentRole === '保险员' || (isAdmin && loginType === '3191') ? 'All settlement' : loginType === '3187' ? 'All rescue' : 'All accidents'
            }}</span>
        </div>
      </div>
      <div class="listcontent">
        <div class="statusbtns" v-if="loginType==='3183'">
          <div :class="statusBtns1" @click="statusSearch(1)">默认全部</div>
          <div :class="statusBtns2" @click="statusSearch(2)">处理中</div>
          <div :class="statusBtns3" @click="statusSearch(3)">已归档</div>
          <el-link
            icon="el-icon-download"
            type="primary"
            class="export-link"
            @click="exportList"
          >
            导出
          </el-link>
        </div>
        <div class="searchform" v-if="allList">
          <div class="searchitem1">
            <span class="searchitem1-laber">事故编号</span>
            <el-input class="searchinput" v-model.trim="query.accidentId"></el-input>
            <span class="searchitem1-laber">接警电话</span>
            <el-input v-model.trim="query.reportPhone"></el-input>
          </div>
          <div class="searchitem1">
            <span class="searchitem1-laber">事故车牌</span>
            <el-input v-model.trim="query.carLicenseNum"></el-input>
            <span class="searchitem1-laber">事故状态</span>
            <dict-select v-model="query.status" type="accident_status"/>
          </div>
<!--          <div class="searchitem1">-->
<!--            <span class="searchitem1-laber">交警大队</span>-->
<!--            <dict-select v-model="query.policeGroupId" type="traffic_police"/>-->
<!--            <span class="searchitem1-laber">处理程序</span>-->
<!--            <dict-select v-model="query.caseDealType" type="case_deal_type"/>-->
<!--          </div>-->
          <div class="searchitem1 searchitem2">
            <span class="searchitem1-laber">事故时刻</span>
            <!-- <el-date-picker
              v-model="accidentDate"
              type="datetimerange"
              value-format="yyyy-MM-dd HH:mm:ss"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              range-separator="至"
            /> -->
            <div class="timepicker">
              <el-date-picker
                v-model="query.accidentStartDate"
                type="datetime"
                placeholder="选择开始时间"
                format='yyyy-MM-dd HH:mm:ss'
                value-format='yyyy-MM-dd HH:mm:ss'
                :time-arrow-control='false'>
              </el-date-picker>
              <el-date-picker
                v-model="query.accidentEndDate"
                type="datetime"
                placeholder="选择结束时间"
                format='yyyy-MM-dd HH:mm:ss'
                value-format='yyyy-MM-dd HH:mm:ss'
                :time-arrow-control='false'>
              </el-date-picker>

            </div>
            <span class="searchitem1-laber"></span>
            <div class="searchbtns">
              <el-button
                type="primary"
                icon="el-icon-search"
                class="search-btn"
                @click="search"
              >搜索
              </el-button
              >
              <el-button
                type="primary"
                icon="el-icon-refresh"
                class="reset-btn"
                @click="reset"
              >重置
              </el-button
              >
            </div>
          </div>
        </div>
        <!-- 表格 -->
        <el-table
          :data="tableData"
          v-on="$listeners"
          v-bind="$attrs"
          row-key="id"
          v-loading="loading"
          :highlight-current-row="false"
          @selection-change="$emit('update:selectedAccidents', $event)"
          :header-cell-style="{background: 'rgba(2, 133, 216, 0.1)', color: '#7CAFFF', fontWeight: 100}"
        >
          <el-table-column type="selection" align="center" v-if="selectedAccidents"/>
          <!-- <div>
        <el-table-column class-name="orderNumber" type="index" label="序号"></el-table-column>
        <div v-for="(item, index) in formValues" :key="index">
          <el-table-column :label="item" :prop="formKeys[index]"></el-table-column>
        </div>
      </div> -->
          <el-table-column class-name="orderNumber" type="index"></el-table-column>
          <el-table-column
            label="事故编号"
            width="180"
          >
            <template slot-scope="scope">
              <span class="tablecell">{{scope.row.thirdAccidentId != null ? scope.row.thirdAccidentId : scope.row.accidentId}}</span>
            </template>
          </el-table-column>
          <el-table-column label="事故时间/地点" prop="accidentTime" width="300">
            <template slot-scope="scope">
              <span class="tablecell">{{
                  scope.row.accidentTime ? scope.row.accidentTime : "----"
                }}</span>
              <span class="tablecell">
                <el-popover
                  placement="top-start"
                  width="200"
                  trigger="hover"
                  :content="scope.row.accidentAddress"
                >
                  <span slot="reference">{{ scope.row.accidentAddress }}</span>
                </el-popover>
              </span>
            </template>
          </el-table-column>
          <el-table-column label="报警电话" prop="reportPhone" width="130">
            <template slot-scope="scope">
              <span class="tablecell">{{
                  scope.row.reportPhone ? scope.row.reportPhone : "----"
                }}</span>
<!--              <span class="tablecell">{{-->
<!--                  scope.row.answerAgent ? scope.row.answerAgent : "&#45;&#45;&#45;&#45;"-->
<!--                }}</span>-->
            </template>
          </el-table-column>
<!--          <el-table-column-->
<!--            label="案件处理程序"-->
<!--            prop="caseDealType"-->
<!--            :formatter="({ caseDealType }) => dictMap.case_deal_type[caseDealType]"-->
<!--          >-->
<!--          </el-table-column>-->
          <el-table-column label="处理状态" width="250">
            <template slot-scope="scope">
              <span v-if="scope.row.liability"
              ><el-icon name="success" class="text-success"></el-icon> 已定责</span
              >
              <span v-else>
                <el-icon name="remove" class="text-warning"></el-icon>
                未定责
              </span>
              <span v-if="scope.row.claim"
              ><el-icon name="success" class="text-success"></el-icon> 已理赔</span
              >
              <span v-else>
                <el-icon name="remove" class="text-warning"></el-icon>
                未理赔
              </span>
<!--              <span v-if="scope.row.upload"-->
<!--              ><el-icon name="success" class="text-success"></el-icon> 已上传</span-->
<!--              >-->
<!--              <span v-else>-->
<!--                <el-icon name="remove" class="text-warning"></el-icon>-->
<!--                未上传-->
<!--              </span>-->
            </template>
          </el-table-column>
<!--          <el-table-column label="费用信息" width="90">-->
<!--            <template slot-scope="scope">-->
<!--              <span>{{ scope.row.claim === 1 ? '已结清' : scope.row.claim === 2 ? '部分结清' : '未结清' }}</span>-->
<!--            </template>-->
<!--          </el-table-column>-->
          <el-table-column
            label="事故状态"
            prop="status"
            :formatter="({ status }) => dictMap.accident_status[status]"
          >
          </el-table-column>
<!--          <el-table-column-->
<!--            label="敏感词"-->
<!--            prop="sensitiveWord"-->
<!--          >-->
<!--            <template slot-scope="scope">-->
<!--            <span v-if="!scope.row.sensitiveWord || scope.row.sensitiveWord === '语音识别失败'">-->
<!--              /-->
<!--            </span>-->
<!--              <span v-else>-->
<!--              <el-popover-->
<!--                placement="top-start"-->
<!--                width="200"-->
<!--                trigger="hover"-->
<!--                :content="scope.row.sensitiveWord"-->
<!--              >-->
<!--                  <span slot="reference">敏感词</span>-->
<!--                </el-popover>-->
<!--            </span>-->
<!--            </template>-->
<!--          </el-table-column>-->
          <el-table-column label="操作" width="200px">
            <div
              class="operator-group"
              slot-scope="{
                row: {
                  accidentAddress,
                  accidentId,
                  thirdAccidentId,
                  liability,
                  claim,
                  status,
                  upload,
                  statementUrl,
                  accidentPartyList,
                  caseDealType,
                  id,
                },
              }"
            >
              <el-link
                class="linkstyle"
                @click="
                  $router.push({
                    name: 'AccidentEdit',
                    params: { id: accidentId, detailId: id },
                  })
                "
              >查看
              </el-link
              >
              <template>

<!--                <el-link-->
<!--                  class="linkstyle"-->
<!--                  v-if="-->
<!--                    !liability && loginType==='3183' &&-->
<!--                    ((currentRole === '交警' && caseDealType && caseDealType === 2) ||-->
<!--                      isAdmin ||-->
<!--                      (currentRole === '坐席' && caseDealType && caseDealType === 1))-->
<!--                  "-->
<!--                  @click="-->
<!--                    () => {-->
<!--                      currentAccidentId = accidentId;-->
<!--                      liabilityVisible = true;-->
<!--                    }-->
<!--                  "-->
<!--                >定责-->
<!--                </el-link>-->
<!--                <el-link-->
<!--                  class="linkstyle"-->
<!--                  v-if="isAdmin || loginType==='3191'"-->
<!--                  @click="-->
<!--                    () => {-->
<!--                      currentAccidentId = accidentId;-->
<!--                      currentUrl = statementUrl;-->
<!--                      verifyVisible = true;-->
<!--                    }-->
<!--                  "-->
<!--                >审核-->
<!--                </el-link>-->
<!--                <el-link-->
<!--                  class="linkstyle"-->
<!--                  v-if="currentRole === '保险员' || (isAdmin && loginType==='3191')"-->
<!--                  @click="-->
<!--                    () => {-->
<!--                      currentAccidentId = accidentId;-->
<!--                      claimVisible = true;-->
<!--                    }-->
<!--                  "-->
<!--                >理赔-->
<!--                </el-link>-->
<!--                <el-link-->
<!--                  class="linkstyle"-->
<!--                  v-if="currentRole === '保险员' || (isAdmin && loginType==='3191')"-->
<!--                  @click="-->
<!--                    () => {-->
<!--                      qrUrl = 'https://wxjj.itindata.cn/h5/#/pages/accidentDetail/accidentDetail?id=' + accidentId;-->
<!--                      qrcodeShow = true;-->
<!--                    }-->
<!--                  "-->
<!--                >二维码-->
<!--                </el-link>-->

<!--                <el-link-->
<!--                  class="linkstyle"-->
<!--                  v-if="currentRole === '保险员'"-->
<!--                  @click="openCallModal(accidentId)"-->
<!--                >一键救援-->
<!--                </el-link>-->
                  <el-link
                    class="linkstyle"
                    v-if="currentRole === '保险员'"
                    @click="
                  $router.push({
                    name: 'patientIndex',
                    params: { id: accidentId, thirdAccidentId: thirdAccidentId},
                  })
                "
                  >诊疗资料
                  </el-link>

              </template>

<!--              <el-link-->
<!--                class="linkstyle"-->
<!--                v-if="!upload && currentRole === '坐席'"-->
<!--                @click="-->
<!--                  () => {-->
<!--                    currentAccidentId = accidentId;-->
<!--                    currentStatementUrl = statementUrl;-->
<!--                    uploadVisible = true;-->
<!--                  }-->
<!--                "-->
<!--              >-->
<!--                上传-->
<!--              </el-link>-->
<!--              <el-link-->
<!--                class="linkstyle"-->
<!--                v-if="upload && currentRole === '坐席'"-->
<!--                @click="viewLiabilityLetter(statementUrl)"-->
<!--              >-->
<!--                定责书-->
<!--              </el-link>-->
<!--              <el-link-->
<!--                v-if="currentRole === '坐席' && thirdAccidentId!=='undefined'&&thirdAccidentId!=null&&thirdAccidentId!==''"-->
<!--                class="linkstyle"-->
<!--                @click="callBack(thirdAccidentId)"-->
<!--              >-->
<!--                回访-->
<!--              </el-link>-->

            </div>
          </el-table-column>
        </el-table>
        <el-pagination
          background
          layout="total, prev, pager, next"
          :total="pagination.total"
          :page-size="8"
          :current-page="pagination.page"
          @current-change="changeCurrentPage"
        >
        </el-pagination>
      </div>
    </div>

    <liability
      :accidentId="currentAccidentId"
      :visible.sync="liabilityVisible"
      @ok="$emit('refresh')"
    />
    <claim
      :accidentId="currentAccidentId"
      :visible.sync="claimVisible"
      @ok="$emit('refresh')"
    />

    <myDialog :logTitle="'上传事故认定书'" :logHeight="'380px'" :showDialog.sync="uploadVisible">
      <upload-statement
        :accidentId="currentAccidentId"
        :statementUrl.sync="currentStatementUrl"
        class="uploadbtn"
      />
      <div class="dialog-footer letter-footer">
        <el-button
          class="letter-cancel"
          @click="() => {
              uploadVisible = false;
            }"
        >
          取 消
        </el-button>
        <el-button
          class="letter-confirm"
          @click="() => {
              uploadVisible = false;
              $emit('getUserInfoToShow');
            }"
        >
          确 定
        </el-button>
      </div>
    </myDialog>
    <!--审核-->
    <myDialog :logTitle="'审核'" :logHeight="'850px'" :showDialog.sync="verifyVisible">
      <div class="closebtn">
        <el-button
          type="primary"
          @click="
            () => {
              verifyVisible = false;
            }
          "
        >关闭
        </el-button
        >
      </div>
      <div class="el-dialog--center"  style="height:850px;overflow-y: auto">
        <el-image style="width: 100%;
          marginright: 0px;
          overflow: auto" :src="currentUrl"></el-image>
      </div>
      <div class="dialog-footer letter-footer">
        <el-button
          class="letter-cancel"
          @click="() => {
              verifyVisible = false;
            }"
        >
          拒 绝
        </el-button>
        <el-button
          class="letter-confirm"
          @click="() => {
              verifyVisible = false;
            }"
        >
          通 过
        </el-button>
      </div>
    </myDialog>
    <!-- 一键救援 -->
    <myDialog :logTitle="'请选择救援对象'" :logHeight="'380px'" :showDialog.sync="callDialogVisible">
      <div class="partylist">
        <el-checkbox-group v-model="checkedParty" @change="handleCheckedCitiesChange">
          <el-checkbox v-for="item in partyList" :label="item.id" :key="item.id">{{
              item.name
            }}
          </el-checkbox>
        </el-checkbox-group>
      </div>
      <div class="rescueFooter">
        <span
          class="partyBtn btn1"
          @click="callDialogVisible = false"
        >
          取 消
        </span>
        <span
          class="partyBtn btn2"
          @click="callRescue"
        >
          确 定
        </span>
      </div>
    </myDialog>
    <!--      <div class="closebtn">-->
    <!--          <el-button-->
    <!--            type="primary"-->
    <!--            @click="-->
    <!--              () => {-->
    <!--                modalShow = false;-->
    <!--              }-->
    <!--            "-->
    <!--            >关闭</el-button-->
    <!--          >-->
    <!--        </div>-->

    <myDialog :logTitle="'定责书'" :logHeight="'640px'" :showDialog.sync="modalShow">
      <div class="closebtn">
        <el-button
          type="primary"
          @click="
            () => {
              modalShow = false;
            }
          "
        >关闭
        </el-button
        >
      </div>
      <div class="imgmodal">
        <div>
          <el-image style="width: 600px;
          height: 700px;
          marginright: 0px;
          <!-- marginleft: 40px; -->
          margintop: 40px;
          overflow: auto" :src="imgUrl"></el-image>
        </div>
      </div>
    </myDialog>

    <!--二维码-->
    <myDialog :logTitle="'定责详情'" :logHeight="'340px'" :showDialog.sync="qrcodeShow">
      <div class="closebtn">
        <el-button
          type="primary"
          @click="
            () => {
              qrcodeShow = false;
            }
          "
        >关闭
        </el-button
        >
      </div>
      <div class="imgmodal">
        <div>
          <vue-qr  :text="qrUrl" :size="200"></vue-qr>
        </div>
      </div>
    </myDialog>

    <!-- 智能外呼 -->
    <myDialog :logTitle="'当事人回访'" :logHeight="'640px'" :showDialog.sync="isCallBackVisible" class="callbackmodal">
      <el-table :data="callBackList" style="width: 100%">
        <el-table-column prop="name" label="姓名" width="65"></el-table-column>
        <el-table-column prop="phone" label="电话" width="110"></el-table-column>
        <el-table-column prop="carNum" label="车牌号" width="105" >
          <template slot-scope="scope">
            <span v-if="scope.row.carNum">{{scope.row.carNum}}</span>
            <span v-else>无</span>
          </template>
        </el-table-column>
        <el-table-column label="回访结果" prop="result" width="80" :formatter="formatSatisfactionResult"/>
        <el-table-column label="满意度" prop="satisfaction" width="80" :formatter="formatSatisfactionSurvey"/>
        <el-table-column label="意见" prop="suggestion" width="200" class="suggestcell">
          <template slot-scope="scope">
            <span class="tablecell">
              <el-popover placement="top-start" width="200" trigger="hover" :content="scope.row.suggestion">
                <span slot="reference">{{ scope.row.suggestion }}</span>
              </el-popover>
            </span>
          </template>
        </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-link @click="callParty(scope.row)" type="text" size="small" style="color: #17ECFE">回访</el-link>
          </template>
        </el-table-column>
      </el-table>
      <div class="callBackClose" @click="closeCallBack">关闭</div>
    </myDialog>

  </div>
</template>

<script>
import {jsPDF} from "jspdf";
import Liability from "@/views/accident/components/Liability";
import Pagination from "@/components/Pagination";
import Claim from "@/views/accident/components/Claim";
import UploadStatement from "@/views/accident/components/UploadStatement.vue";
import {exportAccidentList, req} from "@/api/accident/list";
import DictSelect from "@/views/accident/components/dict-select.vue";
import {getAccidentList} from "@/api/accident/list";
import vueQr from 'vue-qr';

const loginType = localStorage.getItem('loginType')
import myDialog from '@/components/custom/myDialog.vue'
import axios from 'axios'
import fileDownload from "js-file-download";
import {listSatisfaction, sendSatisfaction} from "@/api/followup/followup";
import {uploadStatement} from "@/api/accident/upload";

export default {
  name: "commonAccidentListCom",
  components: {Liability, Claim, UploadStatement, Pagination, DictSelect, myDialog, vueQr},
  props: {
    tableData: {
      type: Array,
      default: () => [],
    },
    selectedAccidents: {
      type: Array,
      required: false,
    },
    pagination: {
      type: Object,
      default: () => ({
        page: 1,
        size: 8,
        total: 0,
        type: 0
      }),
    },
    loading: {type: Boolean, default: false},
  },
  computed: {
    currentRole() {
      return this.$store.getters.accidentRoleName;
    },
    isAdmin() {
      return this.$store.getters.isAdmin;
    },
  },

  data() {
    return {
      currentAccidentId: "",
      liabilityVisible: false,
      verifyVisible: false,
      currentUrl: "",
      claimVisible: false,
      uploadVisible: false,
      currentStatementUrl: "",
      dictMap: {accident_status: {}, case_deal_type: {}, satisfaction_survey:{}, satisfaction_survey_result:{}},
      roleName: "",
      modalShow: false,
      qrcodeShow: false,
      imgUrl: "",
      qrUrl: "",
      callDialogVisible: false,
      partyList: [],
      checkedParty: [],
      accidentId: "",
      allList: true,
      commonBts1: "commonbtn",
      commonBts2: "commonbtn selectedbtn",
      cnTitle1: "cn-title",
      cnTitle2: "cn-title title-selected",
      enTitle1: "english-title",
      enTitle2: "english-title en-selected",
      accidentStatusForSearch: 1,
      statusBtns1: "status1",
      statusBtns2: "status2",
      statusBtns3: "status2  status-selected",
      ang1: "ang1-other",
      ang2: "ang2-other",
      query: {
        accidentId: "",
        accidentStartDate: "",
        accidentEndDate: "",
        status: null
      },
      pageinationShow: true,
      loginType: loginType,
      accidentState: null,
      isCallBackVisible: false,
      callBackList: [],
      directCompensationVisible: false,
      source: []
    };
  },

  mounted() {
    this.isAllList(false)
    console.log(this.$store.getters.searchCondition, 'mounted');
    this.query = this.$store.getters.searchCondition.isSearch ? this.$store.getters.searchCondition.searchQuery : {status: null}
    console.log(this.tableData);
  },
  methods: {
    viewLiabilityLetter(fileUrl) {
      if (fileUrl) {
        window.open(fileUrl)
      } else {
        this.$message.error('没有定责书')
      }
    },
    getNeedDicts() {
      this.getDicts(Object.keys(this.dictMap)).then((data) => {
        this.dictMap = Object.keys(this.dictMap).reduce((acc, dictType) => {
          acc[dictType] = data[dictType].reduce((map, {dictLabel, dictValue}) => {
            map[dictValue] = dictLabel;
            return map;
          }, {});
          return acc;
        }, {});
      });
    },
    openModal(row) {
      this.modalShow = true;
    },
    // 打开一键救援模态框
    openCallModal(id) {
      console.log(id);
      this.callDialogVisible = true;
      this.accidentId = id;
      this.tableData.map((item) => {
        if (item.accidentId === this.accidentId) {
          this.partyList = item.accidentPartyList;
          console.log(this.partyList);
        }
      });
    },
    callRescue() {
      console.log(this.checkedParty, "checkedParty");
      this.callDialogVisible = false;
      for (let i = 0; i < this.checkedParty.length; i++) {
        req("/didireport/report", "post", {
          accidentId: this.accidentId,
          accidentPartyId: this.checkedParty[i],
        })
          .then((res) => {
            this.$message.info(
              this.partyList[i].name + "救援结果为:" + res.data.retMsg === "success"
                ? "成功"
                : res.msg
            );
            console.log(res, i, this.partyList[i].name);
          })
          .catch((err) => {
            this.$message.info(this.partyList[i].name + "救援结果为:" + res.data.retMsg);
            console.log(err, i, this.partyList[i].name);
          });
      }
    },
    handleCheckedCitiesChange(val) {
      console.log(val);
    },

    // backUrl() {
    //   console.log(7777);
    //   callbackUrl({eventInfo:'12345'}).then((res)=>{
    //     console.log(res);
    //   })
    // },
    // 切换今日/所有列表
    async isAllList(state) {
      this.allList = state;
      // this.isPageinationShow();
      if (!state) {
        this.pagination.size = 8;
        this.commonBts1 = "commonbtn selectedbtn";
        this.commonBts2 = "commonbtn";
        this.cnTitle1 = "cn-title title-selected";
        this.cnTitle2 = "cn-title";
        this.enTitle1 = "english-title en-selected";
        this.enTitle2 = "english-title";
        this.ang1 = "ang1";
        this.ang2 = "ang02";
        this.statusBtns1 = "status2  status-selected"
        this.statusBtns2 = 'status2'
        this.statusBtns3 = 'status2'
        const {total, ...params} = this.pagination;
        this.loading = true;
        if (loginType === '3187') {
          params.type = 1
        } else {
          params.type = 0
        }
        req("/accident/list/today", "get", params)
          .then((res) => {
            console.log(res);
            this.tableData = res.data.list;
            this.pagination.total = res.data.total;
          })
          .catch((err) => {
            console.log(err);
          });
        this.loading = false;
        // this.isPageinationShow();
      } else {
        this.pagination.size = 8;
        this.commonBts1 = "commonbtn";
        this.commonBts2 = "commonbtn selectedbtn";
        this.cnTitle1 = "cn-title";
        this.cnTitle2 = "cn-title title-selected";
        this.enTitle1 = "english-title";
        this.enTitle2 = "english-title en-selected";
        this.ang1 = "ang1-other";
        this.ang2 = "ang2-other";
        this.statusBtns1 = 'status2 status-selected'
        this.statusBtns2 = 'status2 '
        this.statusBtns3 = "status2"
        // this.getSearchTime();
        this.loading = true;
        if (loginType === '3187') {
          this.pagination.type = 1
        } else {
          this.pagination.type = 0
        }
        let res2 = await getAccidentList({status: null}, this.pagination);
        this.tableData = res2.data.list;
        this.pagination.total = res2.data.total;
        console.log(res2);
        this.loading = false;
        // this.isPageinationShow();
      }
    },

    // 切换事故状态
    async statusSearch(n) {
      if (n === 1) {
        this.query.status = ''
        this.statusBtns1 = "status1 status-selected";
        this.statusBtns2 = "status2";
        this.statusBtns3 = "status2";
        if (this.allList) {
          this.loading = true;
          let res = await getAccidentList(
            {
              ...this.query,
            },
            this.pagination
          );
          console.log(res.data.list, 222);
          this.tableData = res.data.list;
          this.pagination.total = res.data.total;
          this.loading = false;
        } else {
          const {total, ...params} = this.pagination;
          this.loading = true;
          req("/accident/list/today", "get", params)
            .then((res) => {
              console.log(res, "com");
              this.pagination.total = res.data.total;
              this.tableData = res.data.list;
              this.loading = false;
            })
            .catch((err) => {
              console.log(err);
              this.loading = false;
            });
        }
      }
      if (n === 2) {
        this.query.status = null
        this.statusBtns1 = "status1";
        this.statusBtns2 = "status2 status-selected";
        this.statusBtns3 = "status2";
        if (this.allList) {
          this.loading = true;
          let res = await getAccidentList(
            {
              status: 1,
            },
            this.pagination
          );
          console.log(res.data.list, 222);
          this.tableData = res.data.list;
          this.pagination.total = res.data.total;
          this.loading = false;
        } else {
          const {total, ...params} = this.pagination;
          this.loading = true;
          req("/accident/list/today", "get", {...params, status: null})
            .then((res) => {
              console.log(res, "com");
              this.pagination.total = res.data.total;
              this.tableData = res.data.list;
              this.loading = false;
            })
            .catch((err) => {
              console.log(err);
              this.loading = false;
            });
        }
      }
      if (n === 3) {
        this.query.status = 3
        this.statusBtns1 = "status1";
        this.statusBtns2 = "status2";
        this.statusBtns3 = "status2  status-selected";
        if (this.allList) {
          this.loading = true;
          let res = await getAccidentList(
            {
              status: "3",
            },
            this.pagination
          );
          console.log(res.data.list, 222);
          this.tableData = res.data.list;
          this.pagination.total = res.data.total;
          this.loading = false;
        } else {
          const {total, ...params} = this.pagination;
          this.loading = true;
          req("/accident/list/today", "get", {...params, status: "3"})
            .then((res) => {
              console.log(res, "com");
              this.pagination.total = res.data.total;
              this.tableData = res.data.list;
              this.loading = false;
            })
            .catch((err) => {
              console.log(err);
              this.loading = false;
            });
        }
      }
    },

    // 搜索
    async search() {
      console.log(this.query, 'updatastore');
      this.$store.commit("app/SET_SEARCHCONDITION", {searchQuery: this.query, current: 1, isSearch: true})
      this.pagination.page = 1;
      this.loading = true;

      const formData = {...this.query}
      for (const [key, value] of Object.entries(formData)) {
        if (value === '') {
          delete formData[key]
        }
      }

      let res = await getAccidentList(
        {
          ...formData,
        },
        this.pagination
      );
      console.log(res.data.list, 222);
      this.tableData = res.data.list;
      this.pagination.total = res.data.total;
      this.loading = false;
    },
    // 重置
    async reset() {
      this.query = {
        accidentId: "",
        accidentStartDate: "",
        accidentEndDate: "",
      };
      // this.getSearchTime();
      this.loading = true;
      let res = await getAccidentList(
        {
          ...this.query,
        },
        this.pagination
      );
      console.log(res.data.list, 222);
      this.tableData = res.data.list;
      this.pagination.total = res.data.total;
      this.loading = false;
    },

    // 切换当前页
    async changeCurrentPage(pageInfo) {
      this.$store.commit("app/SET_SEARCHCONDITION", {searchQuery: this.query, current: pageInfo, isSearch: true});
      if (this.allList) {
        let res1 = await getAccidentList(
          {
            ...this.query,
          },
          {
            ...this.pagination,
            page: pageInfo
          }
        );
        this.tableData = res1.data.list;
        this.pagination.total = res1.data.total;
        this.loading = false;
      } else {
        req("/accident/list/today", "get", {size: 8, page: pageInfo})
          .then((res) => {
            console.log(res, "com");
            this.tableData = res.data.list;
            this.pagination.total = res.data.total;
            this.loading = false;
          })
          .catch((err) => {
            console.log(err);
            this.loading = false;
          });
      }
    },

    // 分页器显示
    // isPageinationShow() {
    //   console.log(this.pagination, 1233123);
    //   if (!this.allList) {
    //     this.pageinationShow = this.pagination.total > 6 ? true : false;
    //   } else {
    //     this.pageinationShow = this.pagination.total > 8 ? true : false;
    //   }
    // },

    // 回访
    callBack(thirdAccidentId) {
      listSatisfaction(thirdAccidentId).then(response => {
        this.callBackList = response.data;
        this.isCallBackVisible = true
      });
    },
    formatSatisfactionResult: function (row, column) {
      let satisfactionSurveyResult = this.dictMap.satisfaction_survey_result[row.result]
      return satisfactionSurveyResult ? satisfactionSurveyResult : '/'
    },
    formatSatisfactionSurvey: function (row, column) {
      let satisfactionSurvey = this.dictMap.satisfaction_survey[row.satisfaction]
      return satisfactionSurvey ? satisfactionSurvey : '/'
    },
    // 回访当事人
    callParty(row) {
      sendSatisfaction(row.accidentId, row.phone).then(resp => {
        if (resp.code === 200) {
          this.$message({ message: '回访邀约已发送', type: "success" });
          listSatisfaction(row.accidentId).then(response => {
            this.callBackList = response.data;
          });
        }
      }).catch((e) => {
        console.log(e)
      });
    },

    closeCallBack() {
      this.isCallBackVisible = false
    },


    // 导出列表
    async exportList() {
      const data = await exportAccidentList(
        {
          ...this.query
        },
        this.pagination
      );
      fileDownload(data, "事故列表.xlsx");
    },
    // 查看详情(新标签页中打开)
    // goInfo(accId, detId){
    //   let routeData = this.$router.resolve({
    //       name: 'AccidentEdit',
    //       params: { id: accId, detailId: detId }
    //   })
    //   window.open(routeData.href, '_blank')
    // }

    // 处理时间
    // getSearchTime() {
    //   let time1 = new Date();
    //   let time2 = new Date(time1.getTime() - 259200000);
    //   let mounth1 = time1.getMonth() + 1;
    //   mounth1 = mounth1 > 9 ? mounth1 : "0" + mounth1;
    //   let day1 = time1.getDate() > 9 ? time1.getDate() : "0" + time1.getDate();
    //   let mounth2 = time2.getMonth() + 1;
    //   mounth2 = mounth1 > 9 ? mounth2 : "0" + mounth2;
    //   let day2 = time2.getDate() > 9 ? time2.getDate() : "0" + time2.getDate();
    //   this.query.accidentEndDate =
    //     time1.getFullYear() + "-" + mounth1 + "-" + day1 + " 23:59:59";
    //   this.query.accidentStartDate =
    //     time2.getFullYear() + "-" + mounth2 + "-" + day2 + " 00:00:00";
    //   this.$store.commit("app/SET_SEARCHCONDITION", { ...this.query, accidentId: "" });
    // },
  },
  created() {
    this.getNeedDicts();
  },
};
</script>
<style lang="less">
.operator-group {
  & > *:not(:last-child) {
    margin-right: 10px;
  }
}

.el-pagination {
  margin-top: 20px;
}

.imgmodal {
  width: 640px;
  // padding: 20px;
  // left: ~"calc(50% - 300px)";
  // top: 70px;
  // position: fixed;
  text-align: center;
  z-index: 100;
  // background: rgba(245, 248, 255);
  border-radius: 10px;
}

.imgmodal img {
  margin-right: -80px;
}

.closebtn {
  float: right;
}

.partylist {
  display: flex;
  flex-direction: column;
  height: 235px;
  overflow-y: auto;
}

.rescueFooter {
  text-align: center;
  margin-top: 10px;

  .partyBtn {
    display: inline-block;
    width: 160px;
    height: 48px;
    line-height: 48px;
    border-radius: 4px;
    text-align: center;
    cursor: pointer;
  }

  .btn1 {
    color: #0EBD35;
    background: rgba(14, 189, 53, 0.1);
    border: 1px solid #0EBD35;
    margin-right: 15px;
  }

  .btn2 {
    color: #FF7D00;
    background: rgba(255, 125, 0, 0.1);
    border: 1px solid #FF7D00;
  }
}

.el-table .el-table__header-wrapper th {
  font-weight: 100;
  font-size: 14px !important;
}

.accident-list1 {
  position: relative;
  top: 8px;
  height: 809px;
}

.maincontent {
  height: 796px;

  .changlistbtns {
    width: 420px;
    height: 70px;
    display: flex;
    justify-content: space-between;
    margin-bottom: 10px;

    .commonbtn {
      width: 200px;
      height: 68px;
      border: 1px solid #0084ff;
      color: #b1e3ff;
      font-size: 20px;
      margin-top: 13px;
      display: flex;
      flex-direction: column;
      text-align: center;
      background-image: linear-gradient(#0d2c60, #010345);
      cursor: pointer;

      .cn-title {
        margin-top: 13px;
      }

      .english-title {
        font-size: 12px;
        color: rgba(177, 227, 255, 0.6);
      }

      .title-selected {
        margin-top: 18px;
      }

      .en-selected {
        color: #0ebd35;
      }
    }

    .selectedbtn {
      height: 81px;
      margin-top: 0;
      color: #0ebd35;
      border-bottom: 1px solid #010345;
      z-index: 100;
    }
  }

  .listcontent {
    height: 728px;
    border: 1px solid #0084ff;
    padding-left: 20px;
    padding-right: 20px;
    background: rgba(15, 31, 70, 0.6);

    .statusbtns {
      width: 100%;
      height: 70px;
      // border: 1px solid #0084ff;
      .status1 {
        margin-top: 10px;
        width: 180px;
        height: 48px;
        border: 1px solid #0084ff;
        border-radius: 4px;
        text-align: center;
        line-height: 48px;
        font-size: 20px;
        color: #b1e3ff;
        float: left;
        cursor: pointer;
      }

      .status2 {
        margin-top: 10px;
        width: 160px;
        height: 48px;
        border: 1px solid #0084ff;
        border-radius: 4px;
        margin-left: 10px;
        color: #b1e3ff;
        font-size: 20px;
        text-align: center;
        line-height: 48px;
        float: left;
        cursor: pointer;
      }

      .status-selected {
        border: 1px solid #0ebd35;
        background: url("../assets/images/list/status-selected.png") no-repeat top right;
        color: #0ebd35;
      }
    }

    .searchform {
      height: 170px;
      display: flex;
      justify-content: space-between;
      border-top: 1px solid #0084ff;

      .searchitem1 {
        width: 300px;
        margin-top: -10px;
        display: flex;
        flex-direction: column;

        .searchitem1-laber {
          margin-top: 20px;
          margin-bottom: 10px;
          font-size: 12px;
          color: #17ecfe;
        }

        .searchbtns {
          width: 400px;
          height: 36px;
          margin-top: 16px;

          .search-btn {
            border: 1px solid #0ebd35;
            color: #0ebd35;
            background-color: rgba(14, 189, 53, 0.1);
          }

          .reset-btn {
            background-color: rgba(0, 132, 255, 0.1);
            color: #b1e3ff;
            margin: 0 15px;
          }

          .more-btn {
            background-color: rgba(0, 132, 255, 0.1);
            color: #b1e3ff;
          }
        }

        .searchinput {
          // border: 1px solid #0084ff;
          background-color: transparent !important;
        }

        .el-input--medium .el-input__inner {
          // background-color: transparent;
          // color: #b1e3ff !important;
        }
      }

      .searchitem2 {
        width: 400px;
      }
    }
  }
}

.ang1 {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 150;
}

.ang1-other {
  position: absolute;
  top: 0;
  left: 220px;
  z-index: 150;
}

.ang02 {
  position: absolute;
  top: 0px;
  left: 157px;
  z-index: 150;
}

.ang2-other {
  position: absolute;
  top: 0px;
  left: 377px;
  z-index: 150;
}

.ang2-2 {
  position: absolute;
  top: 78px;
  right: 0;
  z-index: 150;
}

.ang3 {
  position: absolute;
  bottom: 0;
  left: 0;
}

.ang4 {
  position: absolute;
  bottom: 0;
  right: 0;
}

.tablecell {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  display: block;
}

.linkstyle {
  color: #0ebd35;
  font-size: 14px;
}

.status {
  color: red !important;
}

.export-link {
  //background-color: rgba(14, 189, 53, 1);
  width: 160px;
  height: 48px;
  display: block;
  text-align: center;
  line-height: 48px;
  font-size: 20px;
  font-weight: 500;
  color: #ffffff;
  border-radius: 4px;
  float: right;
  margin-top: 10px;
}

.commonBts1 {
  background: rgba(15, 31, 70, 0.6);
}

.pagination-container {
  margin-top: -5px;
}

.uploadbtn {
  .el-upload__tip {
    color: greenyellow;
  }
}

.letter-footer {
  width: 340px;
  margin: 0 auto;
  margin-top: 140px;

  .letter-cancel {
    width: 160px;
    height: 48px;
    color: #B1E3FF;
    font-size: 20px;
    background: rgba(0, 132, 255, 0.1);
    border-radius: 4px;
    border: 1px solid #0084FF;
  }

  .letter-confirm {
    width: 160px;
    height: 48px;
    color: #0EBD35;
    font-size: 20px;
    background: rgba(14, 189, 53, 0.1);
    border-radius: 4px;
    border: 1px solid #0EBD35;
  }

}

.processcontent {
  // width: 100%;
  height: 280px;
  position: relative;
  margin-left: 180px;

  .proBtns {
    display: flex;
    justify-content: space-around;
    margin: 0 auto;
    width: 340px;
    height: 48px;
    position: absolute;
    bottom: 0;

    .proCancle {
      cursor: pointer;
      width: 158px;
      height: 46px;
      border: 1px solid #0084ff;
      background: rgba(0, 132, 255, 0.1);
      font-size: 20px;
      line-height: 46px;
      text-align: center;
      color: #b1e3ff;
      border-radius: 4px;
    }

    .proConfire {
      cursor: pointer;
      width: 158px;
      height: 46px;
      border: 1px solid #0ebd35;
      background: rgba(14, 189, 53, 0.1);
      border-radius: 4px;
      font-size: 20px;
      line-height: 46px;
      text-align: center;
      color: #0ebd35;
    }
  }
}

.callBackClose {
  width: 160px;
  height: 48px;
  background: rgba(0, 132, 255, 0.1);
  border-radius: 4px;
  border: 1px solid #0084FF;
  color: #B1E3FF;
  font-size: 20px;
  text-align: center;
  line-height: 48px;
  position: absolute;
  top: 500px;
  left: 300px;
  cursor: pointer;
}

.timepicker {
  display: flex;
}

.callbackmodal {
  z-index: 160;
}

.suggestcell {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  display: block;
}

.logMain {
  max-height: 490px !important;
  overflow-y: auto;
}
</style>
